import { render, staticRenderFns } from "./DataTableV2ItemNestedTable.html?vue&type=template&id=ea16af38&external"
import script from "./DataTableV2ItemNestedTable.js?vue&type=script&lang=js&external"
export * from "./DataTableV2ItemNestedTable.js?vue&type=script&lang=js&external"
import style0 from "./DataTableV2ItemNestedTable.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
